"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FunctionalStepper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uuid = require("uuid");

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreHeading = _interopRequireDefault(require("@legacy-vfuk/core-heading"));

var _coreLink = _interopRequireDefault(require("@legacy-vfuk/core-link"));

var _coreLinkWithIcon = _interopRequireDefault(require("@legacy-vfuk/core-link-with-icon"));

var _coreMatchMedia = _interopRequireDefault(require("@legacy-vfuk/core-match-media"));

var _reactI18next = require("react-i18next");

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var _coreThemes = require("@legacy-vfuk/core-themes");

var _FunctionalStepper = _interopRequireDefault(require("./themes/FunctionalStepper.theme"));

var Styled = _interopRequireWildcard(require("./styles/FunctionalStepper.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FunctionalStepper = /*#__PURE__*/function (_PureComponent) {
  _inherits(FunctionalStepper, _PureComponent);

  var _super = _createSuper(FunctionalStepper);

  function FunctionalStepper(props) {
    var _this;

    _classCallCheck(this, FunctionalStepper);

    _this = _super.call(this, props);
    _this.componentName = 'FunctionalStepper';
    _this.domRefs = [];

    _this.handleExternalStepClick = function (targetIndex) {
      var targetStepRef = _this.domRefs[targetIndex];
      if (targetStepRef && targetStepRef.current) targetStepRef.current.click();
    };

    _this.state = {
      id: props.id ? props.id : (0, _uuid.v4)()
    };
    return _this;
  }

  _createClass(FunctionalStepper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var currentStepIndex = this.props.currentStep - 1;
      var currentStep = this.props.steps[currentStepIndex]; // Handles cases where component is rendered with the initial step being a link

      if (currentStep.href || currentStep.customRouterProps) this.handleExternalStepClick(currentStepIndex);
    }
  }, {
    key: "getStateIconProps",
    value: function getStateIconProps(index) {
      var isCurrentStep = index + 1 === this.props.currentStep;
      var state = this.props.steps[index].state;
      if (this.props.inverse) return !isCurrentStep ? {
        state: state
      } : {
        inverse: false
      };
      return !isCurrentStep ? {
        state: state
      } : {
        inverse: true
      };
    }
  }, {
    key: "backDisabledProps",
    get: function get() {
      // If current step is the first step, disable the back link
      if (this.props.currentStep === 1) return {
        state: 'disabled'
      }; // Otherwise the back button is always active

      return {};
    }
  }, {
    key: "nextDisabledProps",
    get: function get() {
      // If current step is the same as the number of steps, disable the next link
      if (this.props.currentStep === this.props.steps.length) return {
        state: 'disabled'
      }; // If the step after the current step is in error or success, make the next link active

      var nextStepState = this.props.steps[this.props.currentStep].state;
      if (nextStepState) return {}; // Otherwise it must be active

      return {};
    }
  }, {
    key: "getStepOnClick",
    value: function getStepOnClick(step, index) {
      var _this2 = this;

      // If the step has the onClick method attached to it, then it allows it to be clickable
      if (step.onClick) return {
        onClick: function onClick(event) {
          _this2.handleStepCallback(event, index);
        }
      }; // Otherwise it doesn't pass the onClick method to the StepContainer

      return {};
    }
  }, {
    key: "handleStepCallback",
    value: function handleStepCallback(event, targetIndex) {
      var targetStep = this.props.steps[targetIndex];
      if (targetStep.onClick) targetStep.onClick(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var currentStepIndex = this.props.currentStep - 1;

      var _ref = this.props.inverse ? this.props.localTheme.appearance[this.props.appearance].inverse : this.props.localTheme.appearance[this.props.appearance],
          link = _ref.link,
          controlLink = _ref.controlLink,
          hideControlsHeading = _ref.hideControlsHeading,
          controlHeading = _ref.controlHeading,
          iconAppearance = _ref.iconAppearance;

      return /*#__PURE__*/_react["default"].createElement(Styled.FunctionalStepper, _extends({
        id: this.state.id,
        inverse: this.props.inverse,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.componentName,
        functionalStepperTheme: this.props.localTheme,
        appearance: this.props.appearance
      }, this.props.dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.Steps, null, this.props.steps.map(function (step, index) {
        var isCurrentStep = index + 1 === _this3.props.currentStep;

        _this3.domRefs.push( /*#__PURE__*/(0, _react.createRef)());

        return /*#__PURE__*/_react["default"].createElement(Styled.StepContainer, _extends({
          id: step.id || "".concat(_this3.state.id, "-step-").concat(index),
          key: index,
          interactionRef: _this3.domRefs[index],
          state: step.state,
          inverse: _this3.props.inverse,
          customRouterProps: step.customRouterProps,
          href: step.href
        }, _this3.getStepOnClick(step, index), {
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "step-container-".concat(index)),
          functionalStepperAppearance: _this3.props.appearance,
          functionalStepperTheme: _this3.props.localTheme
        }), /*#__PURE__*/_react["default"].createElement(Styled.StepWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.Step, {
          state: step.state,
          isCurrentStep: isCurrentStep,
          inverse: _this3.props.inverse,
          appearance: _this3.props.appearance,
          functionalStepperTheme: _this3.props.localTheme,
          "data-selector": (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "step-".concat(index))
        }, step.state && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], _extends({
          name: step.state,
          group: "state",
          size: 2
        }, _this3.getStateIconProps(index), {
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "icon-".concat(index))
        })), step.icon && !step.state && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
          appearance: iconAppearance,
          name: step.icon.name,
          group: step.icon.group,
          size: 2,
          inverse: _this3.props.inverse ? !isCurrentStep : isCurrentStep,
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "icon-".concat(index))
        }), !step.icon && !step.state && /*#__PURE__*/_react["default"].createElement("span", {
          "data-selector": (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "span-".concat(index))
        }, index + 1)), /*#__PURE__*/_react["default"].createElement(Styled.TextWrapper, {
          state: step.state,
          inverse: _this3.props.inverse,
          "data-selector": (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "title-".concat(index)),
          functionalStepperTheme: _this3.props.localTheme
        }, step.title)));
      })), /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
        breakpoint: "sm"
      }, /*#__PURE__*/_react["default"].createElement(Styled.StepperMobileControlsContainer, null, /*#__PURE__*/_react["default"].createElement(Styled.StepperMobileControls, {
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'mobile-controls')
      }, this.props.hideControls ? /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
        size: 1,
        weight: 3,
        noMargin: true,
        justify: "center",
        appearance: hideControlsHeading.appearance,
        inverse: hideControlsHeading.inverse,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'current-title')
      }, this.props.steps[this.props.currentStep - 1].title) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], _extends({
        appearance: controlLink.appearance,
        inverse: controlLink.inverse,
        text: this.props.t('Back'),
        icon: {
          name: 'chevron-left',
          justify: 'left'
        },
        onClick: function onClick() {
          _this3.handleExternalStepClick(currentStepIndex - 1);
        }
      }, this.backDisabledProps, {
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'back-link')
      })), /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
        size: 1,
        weight: 3,
        noMargin: true,
        justify: "center",
        appearance: controlHeading.appearance,
        inverse: controlHeading.inverse,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'current-title')
      }, this.props.steps[this.props.currentStep - 1].title), /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], _extends({
        appearance: controlLink.appearance,
        inverse: controlLink.inverse,
        text: this.props.t('Next'),
        icon: {
          name: 'chevron-right',
          justify: 'right'
        },
        onClick: function onClick() {
          _this3.handleExternalStepClick(currentStepIndex + 1);
        }
      }, this.nextDisabledProps, {
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'next-link')
      })))), this.props.steps.find(function (step) {
        return step.errorMessage;
      }) && /*#__PURE__*/_react["default"].createElement(Styled.ErrorListGroup, {
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'errors')
      }, this.props.steps.map(function (step, index) {
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: index
        }, step.errorMessage && (step.state === 'error' || 'warn' || 'info') && /*#__PURE__*/_react["default"].createElement(Styled.ErrorListItem, null, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
          text: step.errorMessage,
          onClick: function onClick() {
            _this3.handleExternalStepClick(index);
          },
          showUnderline: true,
          appearance: link.appearance,
          inverse: link.inverse,
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "error-link-".concat(index))
        })));
      })))));
    }
  }]);

  return FunctionalStepper;
}(_react.PureComponent);

exports.FunctionalStepper = FunctionalStepper;
FunctionalStepper.defaultProps = {
  appearance: 'primary',
  inverse: false,
  currentStep: 1,
  hideControls: false
};
FunctionalStepper.displayName = "FunctionalStepper";

var _default = (0, _coreThemes.withLocalTheme)((0, _reactI18next.withTranslation)()(FunctionalStepper), _FunctionalStepper["default"]);

exports["default"] = _default;
//# sourceMappingURL=FunctionalStepper.js.map